import { FC } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import styled from 'styled-components'
import { TPreReservationFormValues } from '@app.feature/exam/gsat2024-2/constants/form'
import useGetPredictionSelectOptions from '@app.feature/exam/gsat2024-2/hooks/useGetExamTestSelectOptions'
import PredictionInputSelect from '../input/PredictionInputSelect.desktop'
import PredictionFormLabel from '../label/PredictionFormLabel.desktop'

interface IFProps {
  companyId: string
  termId: string
}

const FormItemSubsidiary: FC<IFProps> = ({ companyId, termId }) => {
  const { subsidiaries } = useGetPredictionSelectOptions({ companyId, termId })
  const {
    setValue,
    formState: { errors },
  } = useFormContext<TPreReservationFormValues>()

  const subsidiaryId = useWatch<TPreReservationFormValues, 'subsidiaryId'>({
    name: 'subsidiaryId',
  })

  const handleOnChangeSubsidiary = (value: string) => {
    setValue('subsidiaryId', value, {
      shouldValidate: true,
      shouldDirty: true,
    })
    setValue('departmentId', '', {
      shouldValidate: true,
      shouldDirty: true,
    })
    setValue('jobId', '', {
      shouldValidate: true,
      shouldDirty: true,
    })
  }

  const defaultOption = subsidiaries?.find(
    (subsidary) => subsidary?.value === subsidiaryId,
  )

  return (
    <StyledWrapper>
      <PredictionFormLabel label="계열사" />
      <PredictionInputSelect
        placeholder="계열사 선택"
        isErrors={!!errors.subsidiaryId?.message}
        defaultSelectOption={defaultOption}
        options={subsidiaries}
        onChangeSelect={handleOnChangeSubsidiary}
      />
    </StyledWrapper>
  )
}

export default FormItemSubsidiary

const StyledWrapper = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  margin-right: 66px;

  > p {
    width: 85px;
  }

  > div {
    width: 200px;
  }
`
